export default __webpack_public_path__ + "static/media/image_methode_etape4.15dc9a94.jpg";